import styled from '@emotion/styled';

/**
 * 状态胶囊（带底色）—— 表格、指标卡、权益弹窗统一用它。
 * 文案直接用英文枚举（表格/分档）或中文状态词（权益的已解锁/待解锁），不读 statusText。
 */
export const SpsStatusPill = styled.span<{ status: Dashboard.TikTokUS.Status }>`
  display: inline-block;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  background: ${({ status }) =>
    status === 'POOR' || status === 'CRITICAL'
      ? 'var(--fett-surface-error-bg)'
      : status === 'NIL'
      ? 'var(--fett-bg-subtle)'
      : 'var(--fett-surface-success-bg)'};
  color: ${({ status }) =>
    status === 'POOR' || status === 'CRITICAL'
      ? 'var(--fett-surface-error-text)'
      : status === 'NIL'
      ? 'var(--fett-text-tertiary)'
      : 'var(--fett-surface-success-text)'};
`;

export default SpsStatusPill;
